import styles from "./InfoEditModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import InputText from "../../../../CommonComponents/InputControls/InputText";
import InputSelect from "../../../../CommonComponents/InputControls/InputSelect";
import {
  GENDER_OPTIONS,
  INDUSTRY_OPTIONS,
  SECTORS_OPTION,
  SIZE_PEOPLE_OPTION,
  SIZE_TURNOVER_OPTION,
} from "../../../../../constant";
import InputPhoneNumber from "../../../../CommonComponents/InputControls/InputPhoneNumber";
import useNotification from "../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import InputDate from "../../../../CommonComponents/InputControls/InputDob";
import dayjs from "dayjs";
import AuthServices from "../../../../../services/AuthServices";
import InputEmail from "../../../../CommonComponents/InputControls/InputEmail";

const InfoEditModal = ({ isOpen, onCancel, onSubmit, data }) => {
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [initialData, setInitialData] = useState({});
  const [form] = Form.useForm();
  const [industryOptions, setIndustryOptions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setLoading(false);
      setIndustryOptions(INDUSTRY_OPTIONS[data?.sector] || []);

      const initData = {
        name: data?.Identification?.companyName,
        phoneNumber: data?.Identification?.phoneNumber,
        website: data?.companyUrl,
        email: data?.Identification?.email,
        sector: data?.sector,
        industry: data?.industry,
        companyGlassdoorUrl: data?.companyGlassdoorUrl,
        noOfEmployees: data?.noOfEmployees,
        yearlyRevenue: data?.yearlyRevenue,
      };
      setInitialData(initData);
      form.setFieldsValue(initData);
    }
  }, [isOpen]);

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const onFinish = async (values) => {
    console.warn("values", values);

    try {
      setLoading(true);

      const payload = {
        _id: data
          ._id,
        sector: values.sector,
        industry: values.industry,
        yearlyRevenue: values.yearlyRevenue,
        noOfEmployees: values.noOfEmployees,
        companyGlassdoorUrl: values.companyGlassdoorUrl,
        companyName: values.name,
        Identification: {
          ...data.Identification,
          companyName: values.name,
          email: values.email,
          phoneNumber: values.phoneNumber,
        },
        companyUrl: values.website,
      };
      
      payload.Identification.phoneNumber =
        "+" + values.phoneNumber.countryCode + values.phoneNumber.areaCode + values.phoneNumber.phoneNumber;

      const res = await EnterpriseServices.UpdateEnterprise(payload);

      if (res) {
        if (res.statusCode === 1) {
          onSubmit();
          onCancel(false);
          showNotification("Company banner updated Successfully");
          setLoading(false);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating banner", error);
        handleError(error.description);
      } else {
        handleError("Error: company banner is not updated.");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const validator = (_, { value, countryCode, areaCode, phoneNumber }) => {
    const regex = /^\+\d{1,15}$/;
    const number = "+" + countryCode + areaCode + phoneNumber;

    if (regex.test(number)) {
      return Promise.resolve();
    } else {
      return Promise.reject("Invalid phone number");
    }
  };

  const handleChange = (key, value) => {
    setInitialData({ ...initialData, [key]: value });
    if (key === "sector") {
      setIndustryOptions(INDUSTRY_OPTIONS[value] || []);
      if (INDUSTRY_OPTIONS?.[value]?.[0]) {
        form.setFieldsValue({
          industry: INDUSTRY_OPTIONS?.[value]?.[0],
        });
      }
    }
  };

  return (
    <>
      <Modal
        title="Company Information"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          layout="vertical"
          style={{ marginTop: 20 }}
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ phoneNumber: "8200989898" }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter company name"
                label={"Name"}
                name={"name"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Company name is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            {initialData.phoneNumber && (
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <InputPhoneNumber
                  placeholder="Enter phoneNumber"
                  label={"Phone Number"}
                  onChange={handleChange}
                  name={"phoneNumber"}
                  rules={[{ validator }]}
                />
              </Col>
            )}
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputEmail
                placeholder="Enter your company email address"
                onChange={handleChange}
                label={"Email"}
                name={"email"}
                rules={[
                  {
                    required: true,
                    message: "Email Address is required !",
                    whitespace: false,
                  },
                  {
                    type: "email",
                    whitespace: false,
                    message: "Email must be a valid email address !",
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter your Website"
                label={"Website"}
                name={"website"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Website is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>

            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputSelect
                placeholder="Select sector"
                label={"Sector"}
                name={"sector"}
                onChange={handleChange}
                option={SECTORS_OPTION}
                rules={[
                  {
                    required: true,
                    message: "sector is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputSelect
                placeholder="Select industry"
                label={"Industry"}
                name={"industry"}
                onChange={handleChange}
                option={industryOptions}
                rules={[
                  {
                    required: true,
                    message: "Industry is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <InputText
                placeholder="Enter your glassdoor Url"
                label={"Glassdoor Url"}
                name={"companyGlassdoorUrl"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Glassdoor url is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputSelect
                placeholder="Select size(people)"
                label={"Size(people)"}
                name={"noOfEmployees"}
                onChange={handleChange}
                option={SIZE_PEOPLE_OPTION}
                rules={[
                  {
                    required: true,
                    message: "size(people) is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputSelect
                placeholder="Select size(turnover)"
                label={"Size(people)"}
                name={"yearlyRevenue"}
                onChange={handleChange}
                option={SIZE_TURNOVER_OPTION}
                rules={[
                  {
                    required: true,
                    message: "size(turnover) is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
          </Row>
          <div className={styles.footer}>
            <Form.Item>
              <Button
                className={styles.submit_btn}
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
            <Button
              className={styles.cancel_btn}
              type="secondary"
              loading={false}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default InfoEditModal;
